import { render } from "./SroiComponent.vue?vue&type=template&id=128e6fe4&scoped=true"
import script from "./SroiComponent.vue?vue&type=script&lang=js"
export * from "./SroiComponent.vue?vue&type=script&lang=js"

import "./SroiComponent.vue?vue&type=style&index=0&id=128e6fe4&scoped=true&lang=css"
import "./SroiComponent.vue?vue&type=style&index=1&id=128e6fe4&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128e6fe4"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QExpansionItem,QInput,QPopupProxy,QDate,QTooltip,QBtn,QSpinner});
